(function ($) {

    let filter = {
        postType: '',
        industries: [],
        regions: [],
        search: '',
        annualRevenue: {
            min: '',
            max: ''
        },
        adjustedEBITDA: {
            min: '',
            max: ''
        },
        order: '',
        user_id: '',
        page: 1,
    };

    /**
     * Class constructor
     *
     * @param options
     * @constructor
     */
    function Filter(options) {
        console.log('Filter initialization');

        if (!options) {
            throw new Error('No options passed to Filter constructor');
        } else if (!options.postType) {
            throw new Error('No option postType passed to constructor');
        }

        filter.postType = options.postType;
        this.options = $.extend({}, Filter.defaults, options);

        if (options.user_id) {
            filter.user_id = options.user_id
        }
        this.setup();
    }

    /**
     * Setup base settings
     */
    Filter.prototype.setup = function () {
        let self = this;
        let body = $('body');
        console.log('setup');

        self.resetFilterForms();
        self.prepareIndustries();
        self.prepareSearch();
        self.prepareRegions();

        //Clear filter
        $('.clear_filter').on('click', function (event) {
            event.preventDefault();
            self.closeSidebar();
            $('#filter-selected-items').empty().hide();
            self.resetFilter();
            self.sendRequest(self);
        });

        $('#filter-list-icon').on('click', function (event) {
            event.preventDefault();
            $('#listing-sidebar').toggleClass('listing-sidebar-open');
            $('#header-overlay').addClass('show-overlay');
            body.toggleClass('overflow-hidden');
        });

        $('#header-overlay').on('click', function (event) {
            event.preventDefault();
            self.closeSidebar();
        });

        //Search
        $('#search_submit').on('click', function (event) {
            event.preventDefault();
            self.checkSearchInput();
        });

        //Close information blocks
        body.on('click', '#filter-selected-items .tags a', function (event) {
            event.preventDefault();
            self.clearCheckboxes($(event.target).data('filter-type'), $(event.target).data('value'));
            self.clearInputs($(event.target).data('filter-type'), $(event.target).data('value'));
        });

        //Change ordering
        $('#filter-order').on('change', function (event) {
            event.preventDefault();
            self.changingDisplayOrder();
        });

        //Pagination
        body.on('click', '#pagination a', function (event) {
            console.log('pagination click');
            event.preventDefault();
            filter.page = $(event.target).data('page');
            self.sendRequest(self);
        });

        //Mobile button
        $('.apply_filter').on('click', function (event) {
            console.log('Apply');
            //event.preventDefault();
            self.closeSidebar();
            self.checkInputs();
            self.checkIndustries();
            self.checkRegions();
            self.sendRequest(self, true);
        });

        body.on('click', '#pagination .prev', function (event) {
            event.preventDefault();
            //filter.page
        });

        this.addNumberFields();
    };

    Filter.prototype.closeSidebar = function () {
        console.log('Close sidebar');
        $('#listing-sidebar').removeClass('listing-sidebar-open');
        $('.overlay').removeClass('show-overlay');
        $('body').removeClass('overflow-hidden');
    };

    Filter.prototype.resetFilterForms = function () {
        $('#listing-sidebar input[type=checkbox]').prop('checked', false);
        $('#annual_revenue_min').val(0);
        $('#annual_revenue_max').val(0);
        $('#adjusted_EBITDA_min').val(0);
        $('#adjusted_EBITDA_max').val(0);
        $('#input_search').val('');
    }

    Filter.prototype.addNumberFields = function () {
        new NumberInput({});
    }

    /**
     * Reset filter after reload
     */
    Filter.prototype.resetFilter = function () {
        this.resetFilterForms();

        filter = {
            postType: this.options.postType,
            industries: [],
            regions: [],
            search: '',
            annualRevenue: {
                min: '',
                max: ''
            },
            adjustedEBITDA: {
                min: '',
                max: ''
            },
            order: '',
            page: 1,
        };
    };

    /**
     * Check search input
     */
    Filter.prototype.checkSearchInput = function () {
        filter.search = $('#input_search').val();
        filter.page = 1;
        this.sendRequest(this);
    }

    /**
     * Set default checked industries
     */
    Filter.prototype.prepareIndustries = function () {
        let self = this;
        if (typeof this.options.filterData === 'undefined'
            || typeof this.options.filterData.industrySector === 'undefined'
            || !this.options.filterData.industrySector) {
            return;
        }

        let industries = $('#industry_checkboxes input');
        industries.each(function (key, value) {
            $.each(self.options.filterData.industrySector, function (skey, svalue) {
                if ($(value).data('industry-id') === svalue) {
                    $(value).prop('checked', true);
                    filter.industries.push(svalue);
                    self.addSavedItem($(value).data('item-name'), svalue, 'industry');
                }
            });
        });
    }

    /**
     * Set default checked regions
     */
    Filter.prototype.prepareRegions = function () {
        let self = this;
        if (typeof this.options.filterData === 'undefined'
            || typeof this.options.filterData.regions === 'undefined'
            || !this.options.filterData.regions) {
            return;
        }

        let regions = $('#region_checkboxes input');
        regions.each(function (key, value) {
            $.each(self.options.filterData.regions, function (skey, svalue) {
                if ($(value).data('region-id') === svalue) {
                    $(value).prop('checked', true);
                    filter.regions.push(svalue);
                    self.addSavedItem($(value).data('item-name'), svalue, 'region');
                }
            });
        });
    }

    /**
     * Set default search value
     */
    Filter.prototype.prepareSearch = function () {
        if (typeof this.options.filterData === 'undefined'
            || typeof this.options.filterData.search === 'undefined'
            || !this.options.filterData.search) {
            return;
        }

        filter.search = this.options.filterData.search;
        $('#input_search').val(this.options.filterData.search)
    }

    /**
     * Check industry sector checkboxes
     */
    Filter.prototype.checkIndustries = function () {
        let self = this;
        let industries = $('#industry_checkboxes input:checked');

        filter.industries = [];
        filter.page = 1;
        $.each(industries, function (key, value) {
            let item = $(value);
            let industryID = item.data('industry-id');
            filter.industries.push(industryID);
            self.addSavedItem(item.data('item-name'), industryID, 'industry');
        });
        self.clearSavedItems('industry');
    }

    /**
     * Check region checkboxes
     */
    Filter.prototype.checkRegions = function () {
        let self = this;
        let regions = $('#region_checkboxes input:checked');

        filter.regions = [];
        filter.page = 1;
        $.each(regions, function (key, value) {
            let item = $(value);
            let regionID = item.data('region-id');
            filter.regions.push(regionID);
            self.addSavedItem(item.data('item-name'), regionID, 'region');
        });
        self.clearSavedItems('region');
    }

    /**
     * Add selected item block
     *
     * @param name
     * @param value
     * @param type
     */
    Filter.prototype.addSavedItem = function (name, value, type) {
        let existingElement = $('#filter-selected-items .tags [data-filter-type="' + type + '"][data-value="' + value + '"]');
        if (existingElement.length) {
            return;
        }

        let block = '<div class="tags">';
        block += '<a href="#" data-filter-type="' + type + '" data-value="' + value + '">' + name + '</a>';
        block += '</div>';

        $('#filter-selected-items').show().append(block);
    }

    /**
     * Remove selected item block
     */
    Filter.prototype.clearSavedItems = function (type) {
        let checkboxes = $('#' + type + '_checkboxes input:not(:checked)');
        let savedItems = $('#filter-selected-items .tags a');

        $.each(checkboxes, function (key, value) {
            $.each(savedItems, function (key, savedValue) {
                let el = $(savedValue);
                if (el.data('filter-type') === type
                    && el.data('value') === $(value).data(type + '-id')) {
                    $(savedValue).closest('.tags').remove();
                }
            });
        });

        if (type === 'annual-revenue-min' || type === 'annual-revenue-max'
            || type === 'adjusted-ebitda-min' || type === 'adjusted-ebitda-max') {
            $.each(savedItems, function (key, savedValue) {
                let el = $(savedValue);
                if (el.data('filter-type') === type) {
                    $(savedValue).closest('.tags').remove();
                }
            });
        }

        let filterBlock = $('#filter-selected-items');
        if (!filterBlock.find('.tags a').length) {
            filterBlock.hide();
        }
    }

    /**
     * Clear checkboxes after click by info block
     *
     * @param type
     * @param savedValue
     */
    Filter.prototype.clearCheckboxes = function (type, savedValue) {
        let self = this;
        let checkboxes = $('#' + type + '_checkboxes input:checked');
        $.each(checkboxes, function (key, value) {
            let checkbox = $(value);
            if (checkbox.data(type + '-id') === savedValue) {
                checkbox.prop('checked', false);
                switch (type) {
                    case 'industry':
                        self.checkIndustries();
                        break;
                    case 'region':
                        self.checkRegions();
                }
            }
        });
    }

    Filter.prototype.clearInputs = function (type, savedValue) {
        console.log(type)
        switch (type) {
            case 'annual-revenue-min':
                console.log('aaa');
                $('#annual_revenue_min').val(0);
                filter.annualRevenue.min = '';
                this.clearSavedItems('annual-revenue-min');
                break;
            case 'annual-revenue-max':
                $('#annual_revenue_max').val(0);
                filter.annualRevenue.max = '';
                this.clearSavedItems('annual-revenue-max');
                break;
            case 'adjusted-ebitda-min':
                $('#adjusted_EBITDA_min').val(0);
                filter.adjustedEBITDA.min = '';
                this.clearSavedItems('adjusted-ebitda-min');
                break;
            case 'adjusted-ebitda-max':
                $('#adjusted_EBITDA_max').val(0);
                filter.adjustedEBITDA.max = '';
                this.clearSavedItems('adjusted-ebitda-max');
                break;
        }
        this.sendRequest(this);
    }

    /**
     * Check annual revenue and adjusted EBITDA limits
     */
    Filter.prototype.checkInputs = function () {
        let annualRevenueMin = $('#annual_revenue_min').val();
        let annualRevenueMax = $('#annual_revenue_max').val();

        let adjustedEbitdaMin = $('#adjusted_EBITDA_min');
        let adjustedEbitdaMax = $('#adjusted_EBITDA_max');

        if (!adjustedEbitdaMin.length || !adjustedEbitdaMax.length) {
            adjustedEbitdaMin = 0;
            adjustedEbitdaMax = 0;
        } else {
            adjustedEbitdaMin = adjustedEbitdaMin.val();
            adjustedEbitdaMax = adjustedEbitdaMax.val();
        }

        filter.annualRevenue.min = annualRevenueMin;
        filter.annualRevenue.max = annualRevenueMax;
        filter.adjustedEBITDA.min = adjustedEbitdaMin;
        filter.adjustedEBITDA.max = adjustedEbitdaMax;

        this.clearSavedItems('annual-revenue-min');
        this.clearSavedItems('annual-revenue-max');
        this.clearSavedItems('adjusted-ebitda-min');
        this.clearSavedItems('adjusted-ebitda-max');

        if (filter.annualRevenue.min && parseFloat(filter.annualRevenue.min) !== 0) {
            this.addSavedItem('Min Revenue: ' + filter.annualRevenue.min, filter.annualRevenue.min, 'annual-revenue-min');
        }

        if (filter.annualRevenue.max && parseFloat(filter.annualRevenue.max) !== 0) {
            this.addSavedItem('Max Revenue: ' + filter.annualRevenue.max, filter.annualRevenue.max, 'annual-revenue-max');
        }

        if (filter.adjustedEBITDA.min && parseFloat(filter.adjustedEBITDA.min) !== 0) {
            this.addSavedItem('Min EBITDA: ' + filter.adjustedEBITDA.min, filter.adjustedEBITDA.min, 'adjusted-ebitda-min');
        }

        if (filter.adjustedEBITDA.max && parseFloat(filter.adjustedEBITDA.max) !== 0) {
            this.addSavedItem('Max EBITDA: ' + filter.adjustedEBITDA.max, filter.adjustedEBITDA.max, 'adjusted-ebitda-max');
        }

        filter.page = 1;
    }

    /**
     * Changing display order
     */
    Filter.prototype.changingDisplayOrder = function () {
        filter.order = $('#filter-order option:selected').val();
        filter.page = 1;
        this.sendRequest(this);
    };

    /**
     * Send request
     */
    Filter.prototype.sendRequest = function (self, forcePush) {
        if ($('#apply_filter').is(':visible') && !forcePush) {
            return;
        }
        console.log(filter);
        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: filter,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
            },
            success: function (response) {
                self.parseResponse(response, self);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    Filter.prototype.parseResponse = function (response) {
        console.log(response);
        if (!response.status) {
            console.log('Response error');
            return;
        }

        let toScrollBlock = $('.opportunities-section');
        if (toScrollBlock.length) {
            $('html, body').animate({
                scrollTop: toScrollBlock.offset().top
            }, 500);
        }

        let emptyMessage = $('#empty-message');
        if (response.data) {
            emptyMessage.hide();
        } else {
            emptyMessage.show();
        }

        $('#page-content').empty().append(response.data);
        $('#pagination').empty().append(response.pagination);
        $('#title').empty().append('Filter Results');
    }

    Filter.defaults = {};
    window.Filter = Filter;

})(jQuery);